import { makeStyles } from '@material-ui/core/styles';

export const useLayoutStyles = makeStyles((theme) => ({
	root: {
		position: 'relative'
	},
	body: {
		marginTop: '80px'
	}
}));
